import { Injectable, inject } from '@angular/core';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { CurrentUserService } from './current-user.service';

export interface CompanyAddress {
  streetName: string;
  postalCode?: string;
  city: string;
}

export interface Company {
  id: string;
  name: string;
  slug: string;
  address: CompanyAddress | null;
  website?: string;
  logoUrl?: string;
}

@Injectable({ providedIn: 'root' })
export class CompanyService {
  readonly #firestore = inject(Firestore);
  readonly #currentUser = inject(CurrentUserService);

  /** The current user's companies/{companyId} document (one read). */
  async getCurrentCompany(): Promise<Company | undefined> {
    const { companyId } = await this.#currentUser.requireCompany();
    const snapshot = await getDoc(doc(this.#firestore, 'companies', companyId));
    return snapshot.exists() ? ({ id: snapshot.id, ...snapshot.data() } as Company) : undefined;
  }
}
